import { SocialLoginInput, SocialLoginResult, SocialProvidersAvailable, } from '../../social-auth.js';
/**
 * Its own manifest group rather than more entries under `auth`: the providers
 * are configured per deployment and one of them (`Q-09`) may never ship, so
 * they are kept where they can be added and withdrawn without touching the
 * routes that every member depends on.
 */
export const socialAuthRoutes = {
    /**
     * `:provider` is NOT validated by ContractInterceptor — it validates bodies
     * and queries, not path params — so the handler parses it against
     * `SocialProvider` itself and 404s on anything else.
     */
    login: {
        method: 'POST',
        path: '/auth/social/:provider',
        body: SocialLoginInput,
        response: SocialLoginResult,
    },
    /**
     * What this deployment can actually serve, so a client renders the buttons
     * that work instead of the buttons that were compiled in. A provider with no
     * credentials configured is absent here and 404s on login.
     */
    providers: {
        method: 'GET',
        path: '/auth/social/providers',
        response: SocialProvidersAvailable,
    },
};
//# sourceMappingURL=routes.js.map